const colors = {
    white: '#fff',
    black: '#333333',
    bg: '#F0F5F9',
    navy: {
        main: '#043E6B',
        light: '#CED5DA',
    },
    blue: {
        main: '#0085E6',
        light: 'rgba(0, 133, 230, 0.1)',
        dark: '#0079D1',
        disabled: 'rgba(0, 133, 230, 0.4)',
        hover: 'rgba(0, 133, 230, 0.2)',
    },
    grey: {
        dark: '#545454',
        medium: '#B6B6B6',
        light: '#F9F9F9',
        disabled: '#E8E8E8',
        label: '#F7F8F9',
        labelBorder: '#CFCFD7',
    },
    red: {
        main: '#D73948',
        light: 'rgba(215, 57, 72, 0.1)',
        hover: '#D12A3A',
    },
    green: {
        main: '#37CA83',
        light: 'rgba(55, 202, 131, 0.1)',
        hover: '#30B776',
    },
    yellow: {
        main: '#FFD07D',
        light: 'rgba(255, 208, 125, 0.1)',
        medium: 'rgba(255, 208, 125, 0.5)',
    },
    quote: {
        color: '#D68800',
        border: '#FFD07D',
        backgroundColor: 'rgba(255, 208, 124, 0.1)'
    },
    tentative: {
        color: '#1C1C24',
        border: '#CFCFD7',
        backgroundColor: '#F7F8F9'
    },
    confirmed: {
        color: '#043E6B',
        border: '#0085E6',
        backgroundColor: 'rgba(0, 133, 230, 0.1)'
    },
    cancelled: {
        color: '#D12A3A',
        border: '#D12A3A',
        backgroundColor: 'rgba(209, 42, 58, 0.1)'
    },
    invoiced: {
        color: '#29A368',
        border: '#37CA83',
        backgroundColor: 'rgba(55, 202, 131, 0.1)'
    },
    border: 'rgba(84, 84, 84, 0.2)',
    boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.05)',
};

export default colors;
